import type { InvariantJiraRoute } from '@atlassian/jira-route-types/src/InvariantJiraRoute.tsx';

export const userSegmentationRoute: InvariantJiraRoute = {
	name: 'user-segmentation',
	path: '/jira/get-started',
	exact: true,
};
